module.exports = __webpack_public_path__ + "ce3554994ebf73b451088a95a4ea81ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/amazon_com_2023_chart.png
// module id = 1629
// module chunks = 0